import { ConnectedPersonsListTable } from 'features/person/table/ui/connected-table';

export function PersonListPage() {
  return <ConnectedPersonsListTable />;
}
